import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deleteNewHomeAreaApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.HOME_MAINTENANCE.DELETE_NEW_HOME_AREA,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deleteNewHomeAreaApi;